/* eslint-disable jira/filename-case */

/// <reference path="../../store.d.ts" />
import defaultStorePlugin from 'store/plugins/defaults';
import expirePlugin from 'store/plugins/expire';
import storeEngine from 'store/src/store-engine';
import localStorage from 'store/storages/localStorage';
import memoryStorage from 'store/storages/memoryStorage';
import { fg } from '@atlassian/jira-feature-gating';
import { functionWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/function-with-condition/index.tsx';
import cleanUpPlugin from '../storage-cleanup-plugin/cleanUpPlugin.tsx';

const getPluginsWithCondition = functionWithCondition(
	() => fg('jfp-vulcan-browser-storage-disable-auto-cleanup'),
	() => [defaultStorePlugin],
	() => [defaultStorePlugin, cleanUpPlugin],
);

export const makeLocalStore = (): unknown =>
	storeEngine.createStore([localStorage, memoryStorage], getPluginsWithCondition());

export const isLocalStorageAvailable = (): boolean =>
	typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const makeLocalExpirableStore = (): unknown =>
	storeEngine.createStore([localStorage, memoryStorage], [defaultStorePlugin, expirePlugin]);
